import React, { useEffect } from 'react';
import APIService from '../../../../services/APIService';
import { TWITTER_AUTH_LOCAL_KEY } from '../../../../constants';

const TwitterCallback = () => {
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const state = query.get('state');
    const code = query.get('code');
    const orgId = query.get('orgId');
    const orgConnectionId = query.get('orgConnectionId');
    const twitterAuth: Record<string, string | null> = {
      state,
      code,
    };
    if (orgConnectionId) twitterAuth.orgConnectionId = orgConnectionId;

    const twitterAuthQueryString = Object.keys(twitterAuth)
      .map((key) => `${key}=${twitterAuth[key]}`)
      .join('&');

    APIService.GET(`/org/${orgId}/socialnetworks/twitter/callback?${twitterAuthQueryString}`, undefined, {
      credentials: 'include',
      withCredentials: true,
    })
      .then((results: any) => {
        localStorage.setItem(TWITTER_AUTH_LOCAL_KEY, JSON.stringify(results.data));
        window.close();
      })
      .catch((e: Error) => {
        console.log(e, 'failed to get twitter access token');
      });
  }, []);

  return <div className="margin-top-md margin-left-md">Redirecting...</div>;
};

export default TwitterCallback;
